import Timer from "../layouts/Timer";
import { convertToUTCFormat, formatAmount } from "./format";

const getTableStyles = (activetab) => {
  let tablestyles = "";
  if (activetab === 0) {
    tablestyles = `.dtslist-lead-id{
            width: 7%;
        }
        .dtslist-timelapsed{
            width: 10%;
        }
        .dtslist-requested-on{
            width: 9%;
        }
        .dtslist-customer{
            width: 8%;
        }
        .dtslist-dealer{
            width: 8%;
        }
        .dtslist-city{
            width: 7%;
        }
        .dtslist-status{
            width: 13%;
        }
        .dtslist-substatus{
            width: 14%;
        }
        .dtslist-payment-type{
            width: 7%;
        }
        .dtslist-l0{
            width: 6%;
        }
        .dtslist-l1{
            width: 8%;
        }
        .dtslist-action{
            width: 1%;
        }
        `;
  } else if (activetab === 1) {
    tablestyles = `.dtslist-lead-id{
        width: 6%;
    }
    .dtslist-requested-on{
        width: 10%;
    }
    .dtslist-customer{
        width: 13%;
    }
    .dtslist-dealer{
        width: 13%;
    }
    .dtslist-city{
        width: 10%;
    }
    .dtslist-status{
        width: 15%;
    }
    .dtslist-substatus{
        width: 10%;
    }
    .dtslist-payment-type{
        width: 10%;
    }
    .dtslist-assigned-to{
        width: 10%;
    }
    .dtslist-action{
        width: 4%;
    }
    `;
  } else if (activetab === 2) {
    tablestyles = `.dtslist-lead-id{
        width: 8%;
    }
    .dtslist-requested-on{
        width: 9%;
    }
    .dtslist-customer{
        width: 10%;
    }
    .dtslist-dealer{
        width: 10%;
    }
    .dtslist-city{
        width: 8%;
    }
    .dtslist-status{
        width: 15%;
    }
    .dtslist-substatus{
        width: 8%;
    }
    .dtslist-balance-amt{
        width: 8%;
    }
    .dtslist-l1{
        width: 10%;
    }
    .dtslist-released-by{
        width: 8%;
    }
    .dtslist-reassign-to{
        width: 8%;
    }
    .dtslist-action{
        width: 4%;
    }
    `;
  } else if (activetab === 3) {
    tablestyles = `.dtslist-lead-id{
        width: 8%;
    }
    .dtslist-requested-on{
        width: 10%;
    }
    .dtslist-customer{
        width: 10%;
    }
    .dtslist-dealer{
        width: 10%;
    }
    .dtslist-city{
        width: 10%;
    }
    .dtslist-status{
        width: 15%;
    }
    .dtslist-substatus{
        width: 8%;
    }
    .dtslist-l0{
        width: 9%;
    }
    .dtslist-l1{
        width: 10%;
    }
    .dtslist-released-cancelled-by{
        width: 13%;
    }
    .dtslist-released-by{
        width: 8%;
    }
    .dtslist-action{
        width: 4%;
    }
    `;
  } else if (activetab === 4) {
    tablestyles = `.dtslist-lead-id{
        width: 8%;
    }
    .dtslist-timelapsed{
        width: 10%;
    }
    .dtslist-requested-on{
        width: 10%;
    }
    .dtslist-customer{
        width: 10%;
    }
    .dtslist-dealer{
        width: 10%;
    }
    .dtslist-city{
        width: 10%;
    }
    .dtslist-status{
        width: 15%;
    }
    .dtslist-substatus{
        width: 8%;
    }
    .dtslist-l0{
        width: 9%;
    }
    .dtslist-l1{
        width: 10%;
    }
    .dtslist-released-cancelled-by{
        width: 13%;
    }
    .dtslist-released-by{
        width: 8%;
    }
    .dtslist-action{
        width: 4%;
    }
    `;
  } else if (activetab === 5) {
    tablestyles = `.dtslist-lead-id{
        width: 6%;
    }
    .dtslist-requested-on{
        width: 8%;
    }
    .dtslist-customer{
        width: 10%;
    }
    .dtslist-dealer{
        width: 10%;
    }
    .dtslist-city{
        width: 6%;
    }
    .dtslist-net-dis-amt{
        width: 10%;
    }
    .dtslist-bank-name{
        width: 8%;
    }
    .dtslist-los-id{
        width: 8%;
    }
    .dtslist-loan-type{
        width: 8%;
    }
    .dtslist-action{
        width: 4%;
    }
    `;
  } else {
    tablestyles = `.dtslist-lead-id{
        width: 8%;
    }
    .dtslist-timelapsed{
        width: 10%;
    }
    .dtslist-requested-on{
        width: 10%;
    }
    .dtslist-customer{
        width: 10%;
    }
    .dtslist-dealer{
        width: 10%;
    }
    .dtslist-city{
        width: 10%;
    }
    .dtslist-status{
        width: 15%;
    }
    .dtslist-substatus{
        width: 8%;
    }
    .dtslist-assign-to{
        width: 9%;
    }
    .dtslist-payment-type{
        width: 8%;
    }
    .dtslist-action{
        width: 4%;
    }
    `;
  }
  return tablestyles;
};

const getTimeLapsedDiv = (activeTab, sub_stage, startdate, enddate) => {
  let time_lapsed = "--";
  let diff =
    !enddate || !startdate ? "0" : new Date(enddate) - new Date(startdate);

  let raised_date = "";
  if ([0, 4, 6, 7].includes(activeTab)) {
    raised_date = !startdate
      ? ""
      : convertToUTCFormat(new Date(startdate), "dd-MM-yyyy kk:mm:ss");
  }

  if (sub_stage && [8, 9, 10, 11].includes(parseInt(sub_stage))) {
    diff = diff / 1000;
    const days = Math.floor(diff / 3600 / 24),
      hours = days * 24 + Math.floor((diff % (24 * 3600)) / 3600);

    let minutes = Math.floor((diff % 3600) / 60);
    minutes = minutes > 9 ? minutes : `0${minutes}`;
    let seconds = Math.floor(diff % 60);
    seconds = seconds > 9 ? seconds : `0${seconds}`;
    time_lapsed = `${hours}:${minutes}:${seconds}`;
    time_lapsed = (
      <div className="jst-timeout btn btn-sm no-limit">{time_lapsed}</div>
    );
  } else if (startdate) {
    diff =
      (new Date() -
        new Date(
          convertToUTCFormat(new Date(startdate), "yyyy-MM-dd HH:mm:ss")
        )) /
      1000;

    const lapsed = 120 - Math.floor(Math.abs(diff / 60));
    const lapsedInSeconds = 7200 - Math.floor(diff);
    if (lapsed < 0) {
      time_lapsed = Math.abs(lapsed);
      let hours = Math.floor(time_lapsed / 60);
      hours = hours > 9 ? hours : `0${hours}`;
      let minutes = Math.floor(time_lapsed % 60);
      minutes = minutes > 9 ? minutes : `0${minutes}`;
      time_lapsed = `${hours}:${minutes}:00`;
      time_lapsed = (
        <div
          className="jst-timeout btn btn-sm exceed-limit"
          data-minutes-left={`${lapsed}`}
        >
          -{time_lapsed}
        </div>
      );
    } else {
      time_lapsed = <Timer totalTimeInSeconds={lapsedInSeconds} />;
    }
  } else {
    time_lapsed = (
      <div
        className="jst-timeout btn btn-sm no-limit"
        data-minutes-left={`${time_lapsed}`}
      >
        00:00:00
      </div>
    );
  }
  return { raised_date, time_lapsed };
};

const getLeadIdHtml = (caseObj, user, productTypeObj) => {
  let HoldLevel = "",
    PrePaymentLabel =
      caseObj.is_prepayment_raised && caseObj.is_prepayment_raised === 1 ? (
        <div style={{ padding: "0px", margin: "5px -10px" }}>
          <img
            src={`${process.env.REACT_APP_STYLES_PATH}instant%20loan%20ribbon.png`}
            alt=""
          />
        </div>
      ) : (
        ""
      ),
    case_type_style =
      caseObj.case_type === "restricted"
        ? "#f00000"
        : caseObj.case_type === "caution"
          ? "#f9c834"
          : caseObj.case_type === "normal"
            ? "#038603"
            : "";

  const hodReason = caseObj?.hold_remark
    ? `${caseObj?.hold_reason}. Remarks: ${caseObj?.hold_remark}`
    : caseObj?.hold_reason;

  if (caseObj.hold_case_status === 1 && caseObj.resolved_status !== 2) {
    HoldLevel = <label className="ribbon ribbon-danger" >On Hold<i
      className="fa fa-info-circle"
      title={hodReason || "This case is currently on hold"}
      style={{ marginLeft: "5px", cursor: "pointer", color: "#FFF" }}
    ></i></label>;
  } else if (caseObj.resolved_status && caseObj.resolved_status === 2) {
    HoldLevel = <label className="ribbon ribbon-success"  >Hold Resolved <i
      className="fa fa-info-circle"
      title={hodReason || "This case is currently on hold"}
      style={{ marginLeft: "5px", cursor: "pointer", color: "#FFF" }}
    ></i></label>;
  }

  if (caseObj.stp_qualified && caseObj.stp_qualified === 1) {
    HoldLevel = (
      <>
        {HoldLevel}
        <label className="ribbon ribbon-qualified">STP Qualified</label>
      </>
    );
  }

  //   if (caseObj.fcm_bank_id === 17 && holdLevel !== "") {
  //     holdLevel += <label className="ribbon ribbon-insta-bt">Insta</label>;
  //   } else if (caseObj.fcm_bank_id === 17) {
  //     holdLevel += <label className="ribbon ribbon-insta">Insta</label>;
  //   }

  if (
    Object.values(productTypeObj).includes(caseObj.product_type) &&
    HoldLevel
  ) {
    HoldLevel = (
      <>
        {HoldLevel}
        <label className="ribbon ribbon-new2w-bt">New 2W</label>
      </>
    );
  } else if (Object.values(productTypeObj).includes(caseObj.product_type)) {
    HoldLevel = (
      <>
        {HoldLevel}
        <label className="ribbon ribbon-new2w">New 2W</label>
      </>
    );
  }
  const NetDisAmt =
    ["PLEAD", "HOD"].includes(user.dts_user) &&
      caseObj.net_disbursement_amount ? (
      <i className="fa fa-rupee" style={{ color: "#919192", fontSize: "11px" }}>
        {formatAmount(caseObj.net_disbursement_amount)}
      </i>
    ) : (
      ""
    );
  return (
    <>
      {HoldLevel}
      {PrePaymentLabel}
      <label style={{ color: case_type_style }}>
        {!caseObj.lead_id ? "--" : caseObj.lead_id}
      </label>
      <br />
      {NetDisAmt}
    </>
  );
};

const getSortingClass = (sortingColumns, column) => {
  return sortingColumns[column] === 1
    ? "_asc"
    : sortingColumns[column] === -1
      ? "_desc"
      : "";
};

export { getTableStyles, getTimeLapsedDiv, getLeadIdHtml, getSortingClass };
